///// <reference path="../../typings/react/react-global.d.ts" />

/// <reference path="../typings/Common.d.ts" />

import * as React from "react";

import JsonViewer from './JsonViewer'
import Headers from './Headers'

export interface ICommunicationDataTabState {
    isRequestActive?: boolean,
    isBodyActive?: boolean
}

export interface ICommunicationDataState {
    tabState?: ICommunicationDataTabState
}

export interface ICommunicationDataProps {
    activeData: IActionData
}

export default class CommunicationData extends React.Component<ICommunicationDataProps, ICommunicationDataState> {
    constructor() {
        super();

        this.state = {
            tabState: {
                isRequestActive: true,
                isBodyActive: true
            }
        };
    }
    
    handleMainTabClick(isRequest: any, a: any, b: any, c: any) {
        this.setState({
            tabState: {
                isRequestActive: isRequest, 
                isBodyActive: this.state.tabState.isBodyActive
            }
        });
    }
    
    handleSubTabClick(isBody: boolean) {
        this.setState({
            tabState: {
                isRequestActive: this.state.tabState.isRequestActive, 
                isBodyActive: isBody
            }
        });
    }

    render() {
        var body: any = undefined;
        var activeData: IActionData = this.props.activeData ? this.props.activeData : {
            RequestHeaders: {},
            ResponseHeaders: {},
            Guid: '',
            RequestJson: '{}',
            ResponseJson: '{}',
            RequestUri: '',
            ResponseStatusCode: '',
            DateTime: '',
            RequestMethod: ''
        };
        
        if(this.state.tabState.isBodyActive) {
            let data: string = undefined;
            if (this.state.tabState.isRequestActive) {
                data = activeData.RequestJson;
            } else {
                data = activeData.ResponseJson;
            }
            
            body = <JsonViewer data={data}/>
        } else {
            let data: IStringArray = undefined;
            if (this.state.tabState.isRequestActive) {
                data = activeData.RequestHeaders;
            } else {
                data = activeData.ResponseHeaders;
            }
            
            body = <Headers data={data} />
        }        
        
        return (
            <div>
                <div className="row panel panel-default mainGridHeader">
                    <form className="form-horizontal">
                        <div className="form-group">
                            <label className="col-md-1 control-label">Request Uri: </label>
                            <div className="col-md-3">
                                <span className="form-control">{activeData.RequestUri}</span>
                            </div>
                            <label className="col-md-2 control-label">Response Status Code: </label>
                            <div className="col-md-3">
                                <span className="form-control">{activeData.ResponseStatusCode}</span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-1 control-label">DateTime: </label>
                            <div className="col-md-3">
                                <span className="form-control">{activeData.DateTime}</span>
                            </div>
                            <label className="col-md-2 control-label">Request Method: </label>
                            <div className="col-md-3">
                                <span className="form-control">{activeData.RequestMethod}</span>
                            </div>
                        </div>
                    </form>
                </div>
                <ul className="nav nav-tabs">
                    <li className={this.state.tabState.isRequestActive ? "active" : ""}>
                        <a onClick={this.handleMainTabClick.bind(this, true)}>Request</a>
                    </li>
                    <li className={!this.state.tabState.isRequestActive ? "active" : ""}>
                        <a onClick={this.handleMainTabClick.bind(this, false)}>Response</a>
                    </li>
                </ul>
                <ul className="nav nav-tabs nav-tabs-pf">
                    <li className={this.state.tabState.isBodyActive ? "active" : ""}>
                        <a onClick={this.handleSubTabClick.bind(this, true)}>Body</a>
                    </li>
                    <li className={!this.state.tabState.isBodyActive ? "active" : ""}>
                        <a onClick={this.handleSubTabClick.bind(this, false)}>Headers</a>
                    </li>
                </ul>
                {body}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/CommunicationData.tsx